import { render, staticRenderFns } from "./NewHolidyDlg.vue?vue&type=template&id=f0952252&scoped=true"
import script from "./NewHolidyDlg.vue?vue&type=script&lang=js"
export * from "./NewHolidyDlg.vue?vue&type=script&lang=js"
import style0 from "./NewHolidyDlg.vue?vue&type=style&index=0&id=f0952252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0952252",
  null
  
)

export default component.exports